import { useState } from 'react'
import { useView } from '@10000/react'
import { Avatar, Body, Box, Button, Dialog, H4, ItemPill } from '../'

export const OrganisationDialog = ({ onSelected, onClose, ...props }) => {
  const { organisations } = useView('tenant')
  const [selectedOrganisation, setSelectedOrganisation] = useState()

  const handleClose = () => {
    if(organisations.length === 0 && selectedOrganisation === undefined){
      onClose()
    } else if(selectedOrganisation !== undefined){
      onSelected(selectedOrganisation)
      setSelectedOrganisation(undefined)
      onClose()
    }
  }

  return <Dialog {...props} onClose={onClose} mobileBackground="white">
    <H4 color="black">Select Organisation</H4>
    {organisations.length > 0
      ? <Box fullWidth gap={8} maxHeight={200} p="4px 4px" overflowX="visible" overflowY="auto" column>
          {organisations.map(({ id, avatar, name }, index) =>
            <ItemPill
              action={avatar === undefined}
              index={index}
              key={index}
              blackListBackgrounds={['white']}
              onClick={() => setSelectedOrganisation(id)}
              selected={selectedOrganisation === id}
            >
              <Box fullWidth alignItems="center" gap={8}>
                <Avatar size="small" index={avatar} mode="team"/>
                <Box fullWidth>
                  <Body bold align="left">{name || 'Unnamed organisation'}</Body>
                </Box>
              </Box>
            </ItemPill>
          )}
        </Box>
      : <ItemPill action>
          <Box fullWidth alignItems="center" gap={8}>
            <Avatar size="small" mode="team"/>
            <Box fullWidth>
              <Body bold align="left">No organisations</Body>
            </Box>
          </Box>
        </ItemPill>
    }

    <Button fullWidth onClick={handleClose}>{organisations.length > 0 ? 'Save' : 'Done'}</Button>
  </Dialog>
}